export enum UserStorage {
	UserLogin = "userLogin",
	UserLoginSupportAccountant = "userLoginSupportAccountant"
}
